var exports = {
  "cy": "x234b8571--8044e7--author",
  "my": "x234b8571--8044e7--avatar",
  "O0": "x234b8571--8044e7--rating",
  "uf": "x234b8571--8044e7--stars",
  "jB": "x234b8571--8044e7--newbuilding",
};

module.exports = exports;
